export default "00e4647515038e06.svg"